import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { DecedentValidationRequest, DecedentValidationResponse } from '@interfaces';
import { IClientAccounts } from '@interfaces/models/client-accounts.interface';
import { Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DecedentSecurityService {
  constructor(private http: HttpClient) {}

  validateDecedent(payload: DecedentValidationRequest): Observable<DecedentValidationResponse> {
    return this.http.post<DecedentValidationResponse>('/secure/decedent-validation', payload);
  }

  getDecedentAccounts(payload: { ssn: string }): Observable<IClientAccounts> {
    return this.http.post<IClientAccounts>('/secure/decedent-accounts', payload);
  }
}
